module.exports = __webpack_public_path__ + "static/media/screen-icon-grey.e94c874d.svg";